import { useEffect } from 'react';

import { getCardConnectSrc } from '@/utils/cardConnectIFrameUtils';
import { cardConnectUrl } from '@/utils/constants';

function CardConnectTokenizer({
  tokenized,
}: {
  tokenized: (token: string, expiry: string) => void;
}) {
  useEffect(() => {
    const processTokenMessage = (event: MessageEvent) => {
      if (!event.origin.includes('cardconnect')) return;

      const message = JSON.parse(event.data);

      const { message: token, expiry } = message;
      tokenized(token, expiry);
    };
    window.addEventListener('message', processTokenMessage, false);
    return () => window.removeEventListener('message', processTokenMessage);
  }, [tokenized]);

  const cardConnectSrc = getCardConnectSrc(cardConnectUrl);

  return (
    <iframe
      style={{ height: '275px', margin: 0, padding: 0 }}
      src={cardConnectSrc}
      frameBorder='0'
      scrolling='no'
    ></iframe>
  );
}

export default CardConnectTokenizer;
